import PortalIdParser from 'PortalIdParser';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
import { queryTrackingUrlsPagedRpc } from 'framework-asset-preview-lib/__generated__/chirp/com/hubspot/tracking/url/builder/chirp/TrackingUrlBuilderRpc';
import { TRACKING_URL_PAGE_SIZE } from 'framework-asset-preview-lib/utils/constants';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
export async function fetchTrackingUrlsAsCrmSearchResponse(campaignGuid, offset = 0, pageLength = TRACKING_URL_PAGE_SIZE) {
  if (!campaignGuid) {
    return Promise.resolve({
      results: [],
      total: 0,
      hasMore: false,
      offset: 0
    });
  }
  const requestPayload = {
    query: {
      campaignGuid,
      limit: pageLength
    },
    offset,
    pageLength
  };
  const response = await chirpClient.call(queryTrackingUrlsPagedRpc, {
    request: requestPayload
  });
  return {
    results: response.trackingUrls.map(trackingUrl => {
      var _trackingUrl$shortUrl, _trackingUrl$shortUrl2;
      return {
        objectId: trackingUrl.id,
        objectTypeId: OBJECT_TYPE.TRACKING_URL,
        portalId: PortalIdParser.get(),
        properties: {
          hs_name: {
            value: trackingUrl.url || trackingUrl.trackingUrl || ((_trackingUrl$shortUrl = trackingUrl.shortUrl) === null || _trackingUrl$shortUrl === void 0 ? void 0 : _trackingUrl$shortUrl.url) || ''
          },
          hs_lastmodifieddate: {
            value: String(trackingUrl.updatedAt || '')
          },
          hs_short_url: {
            value: ((_trackingUrl$shortUrl2 = trackingUrl.shortUrl) === null || _trackingUrl$shortUrl2 === void 0 ? void 0 : _trackingUrl$shortUrl2.url) || ''
          },
          hs_tracking_url: {
            value: trackingUrl.trackingUrl || ''
          },
          hs_url: {
            value: trackingUrl.url || ''
          },
          hs_origin_asset_id: {
            value: String(trackingUrl.id)
          }
        }
      };
    }),
    total: response.totalCount,
    hasMore: response.hasMore,
    offset: response.offset
  };
}